import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Decimal } from '@instructure/quiz-i18n';
import { formatScientificNotation, getScientificNotation, parseScientificNotation } from '@instructure/quiz-scientific-notation';
import NumberInput from './NumberInput';
import formatValue from '../util/formatValue';
import _getPrecision from '../util/getPrecision';
import { xor } from '../util/xor';
export var ScientificNumberInput = /*#__PURE__*/function (_Component) {
  function ScientificNumberInput() {
    var _this;
    _classCallCheck(this, ScientificNumberInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ScientificNumberInput, [].concat(args));
    _defineProperty(_this, "_input", null);
    _defineProperty(_this, "handleBlur", function (event) {
      var scientificNotation = getScientificNotation(_this.props.value);
      if (scientificNotation) {
        var _parseScientificNotat = parseScientificNotation(_this.props.value),
          _parseScientificNotat2 = _slicedToArray(_parseScientificNotat, 2),
          mantissa = _parseScientificNotat2[0],
          exponent = _parseScientificNotat2[1];
        var normalizedMantissa = formatValue(new Decimal(mantissa), _this.getPrecision());
        var value = formatScientificNotation(normalizedMantissa, exponent, scientificNotation);
        if (value !== _this.props.value) {
          _this.props.onChange(event, value, value);
        }
      }
      _this.props.onBlur(event);
    });
    _defineProperty(_this, "handleChange", function (event, value, normalizedValue) {
      var scientificNotation = getScientificNotation(value);
      if (scientificNotation) {
        var _this$props = _this.props,
          decimalPrecision = _this$props.decimalPrecision,
          significantDigits = _this$props.significantDigits;
        var _parseScientificNotat3 = parseScientificNotation(value),
          _parseScientificNotat4 = _slicedToArray(_parseScientificNotat3, 2),
          mantissa = _parseScientificNotat4[0],
          exponent = _parseScientificNotat4[1];
        var precision = _this.getPrecision({
          decimalPrecision: decimalPrecision,
          significantDigits: significantDigits,
          value: mantissa
        });
        var normalizedMantissa = formatValue(new Decimal(mantissa), precision);
        _this.props.onChange(event, value, formatScientificNotation(normalizedMantissa, exponent, scientificNotation));
      } else {
        _this.props.onChange(event, value, normalizedValue);
      }
    });
    _defineProperty(_this, "handleRef", function (element) {
      _this._input = element;
      _this.props.inputRef(element);
    });
    _defineProperty(_this, "initialNormalization", function (value, normalized) {
      var scientificNotation = getScientificNotation(value);
      if (scientificNotation) {
        var _this$props2 = _this.props,
          decimalPrecision = _this$props2.decimalPrecision,
          significantDigits = _this$props2.significantDigits;
        var _parseScientificNotat5 = parseScientificNotation(value),
          _parseScientificNotat6 = _slicedToArray(_parseScientificNotat5, 2),
          mantissa = _parseScientificNotat6[0],
          exponent = _parseScientificNotat6[1];
        var precision = _this.getPrecision({
          decimalPrecision: decimalPrecision,
          significantDigits: significantDigits,
          value: mantissa
        });
        var normalizedMantissa = formatValue(new Decimal(mantissa), precision);
        _this.props.onInitialNormalization(formatScientificNotation(normalizedMantissa, exponent, scientificNotation));
      } else {
        _this.props.onInitialNormalization(normalized);
      }
    });
    return _this;
  }
  _inherits(ScientificNumberInput, _Component);
  return _createClass(ScientificNumberInput, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var scientificNotation = getScientificNotation(nextProps.value);
      if (!scientificNotation) return;
      var decimalPrecision = nextProps.decimalPrecision,
        significantDigits = nextProps.significantDigits;
      if (this.props.decimalPrecision === decimalPrecision && this.props.significantDigits === significantDigits) return;
      var nextPrecision = this.getPrecision(nextProps);
      var _parseScientificNotat7 = parseScientificNotation(nextProps.value),
        _parseScientificNotat8 = _slicedToArray(_parseScientificNotat7, 2),
        mantissa = _parseScientificNotat8[0],
        exponent = _parseScientificNotat8[1];
      var normalizedMantissa = formatValue(new Decimal(mantissa), nextPrecision);
      var value = formatScientificNotation(normalizedMantissa, exponent, scientificNotation);
      nextProps.onChange(null, value, value);
    }
  }, {
    key: "focus",
    value: function focus() {
      this._input.focus();
    }
  }, {
    key: "getPrecision",
    value: function getPrecision() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      return _getPrecision(props, '.');
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(NumberInput, Object.assign({}, this.props, {
        ref: this.handleRef,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        value: this.props.value,
        onInitialNormalization: this.initialNormalization
      }));
    }
  }]);
}(Component);
_defineProperty(ScientificNumberInput, "propTypes", {
  decimalPrecision: xor(PropTypes.number, 'significantDigits'),
  inputRef: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  significantDigits: xor(PropTypes.number, 'decimalPrecision'),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onInitialNormalization: PropTypes.func,
  isRequired: PropTypes.bool
});
_defineProperty(ScientificNumberInput, "defaultProps", {
  decimalPrecision: void 0,
  inputRef: function inputRef(element) {},
  onBlur: function onBlur(event) {},
  onChange: function onChange(event, value, normalizedValue) {},
  significantDigits: void 0,
  value: void 0,
  onInitialNormalization: Function.prototype,
  isRequired: false
});
export default ScientificNumberInput;